import { render } from "./editTemplateEmailForInviteCustomer.vue?vue&type=template&id=242c370f&scoped=true"
import script from "./editTemplateEmailForInviteCustomer.vue?vue&type=script&lang=js"
export * from "./editTemplateEmailForInviteCustomer.vue?vue&type=script&lang=js"

import "./editTemplateEmailForInviteCustomer.vue?vue&type=style&index=0&id=242c370f&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242c370f"]])

export default __exports__